export default __webpack_public_path__ + "static/media/tuturu.0aee035e.mp3";